import * as msal from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    authority: `${process.env.REACT_APP_AUTH_AZURE_CLOUD_ID}/${process.env.REACT_APP_AUTH_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_HOME,
    postLogoutRedirectUri: process.env.REACT_APP_APP_HOME,
    scopes: [
      `${process.env.REACT_APP_AUTH_AZURE_SCOPE_URL}`,
      "offline_access",
      "openid",
    ],
    prompt: 'login',
    // Add knownAuthorities here
    knownAuthorities: [`${process.env.REACT_APP_AUTH_AZURE_CLOUD_ID}`], // Replace with the domain of your authority, e.g., "login.microsoftonline.com"
  },
  cache: {
    cacheLocation: "sessionStorage",
    scopes: [process.env.REACT_APP_AUTH_AZURE_SCOPE_URL],
  },
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export default msalInstance;